/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import classNames from 'classnames';
import React, {useEffect, useState } from 'react';
import {getCountryLabel} from "../../util/countryUtil";

interface Props {
    countryCode: string;
    className?: string;
}

export default function CountryFlag(props: Props) {
    const {countryCode, className} = props;
    const [countryLabel, setCountryLabel] = useState('');

    useEffect(() => {
        setCountryLabel(getCountryLabel(countryCode));
    }, [countryCode]);

    return (
        <span className={classNames('fi', `fi-${countryCode.toLowerCase()}`, className)}
              title={countryLabel}/>
    )
}